/*
 * @Describe: kb桥接
 * @Author: wangalong
 * @LastEditTime: 2022-09-19 13:52:41
 */
export const kbBridge: {
    registerHandler: (name: any, registerCallback: any) => void;
    callHandler: (name: any, params: any, callback: any) => void;
} = (() => {
    if (/(kb_dsbridge_android)/i.test(window.navigator.userAgent)) {
        return require('./helper/dsbridge')
    }
    if (/(kb_dsbridge_flutter)/i.test(window.navigator.userAgent)) {
        return require('./helper/flutterDsbridge')
    }
    return require('./helper/bridge')
})()